import { useState, useEffect } from "react";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });

const TYPES = [{id:"reserve",lbl:"Réserve",ic:"⚠️",c:"#f5a623"},{id:"non_conformite",lbl:"Non-conformité",ic:"🔴",c:"#ef4444"},{id:"observation",lbl:"Observation",ic:"💬",c:"#5b6ef8"}];
const CRITICITES = [{id:"mineure",lbl:"Mineure",c:"#22d3a0"},{id:"majeure",lbl:"Majeure",c:"#f5a623"},{id:"critique",lbl:"Critique",c:"#ef4444"}];
const STATUTS = {ouverte:{lbl:"Ouverte",c:"#ef4444"},en_cours:{lbl:"En cours",c:"#f5a623"},resolue:{lbl:"Résolue",c:"#22d3a0"}};

export default function NonConformites({ T, intervention, onClose }) {
  const [list, setList]         = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm]         = useState({titre:"",description:"",type:"reserve",criticite:"mineure"});
  const [saving, setSaving]     = useState(false);

  useEffect(()=>{ load(); },[]);

  const load = async () => {
    const res = await fetch(`${BASE}/non-conformites?intervention_id=${intervention.id}`,{headers:h()}).then(r=>r.json()).catch(()=>[]);
    setList(Array.isArray(res)?res:[]);
  };

  const create = async () => {
    setSaving(true);
    await fetch(`${BASE}/non-conformites`,{method:"POST",headers:h(),body:JSON.stringify({...form,intervention_id:intervention.id})});
    setSaving(false); setShowCreate(false);
    setForm({titre:"",description:"",type:"reserve",criticite:"mineure"});
    load();
  };

  const resolve = async (id) => {
    const res = prompt("Description de la résolution :");
    if (!res) return;
    await fetch(`${BASE}/non-conformites/${id}`,{method:"PATCH",headers:h(),body:JSON.stringify({statut:"resolue",resolution:res})});
    load();
  };

  return (
    <div style={{position:"fixed",inset:0,background:"rgba(8,12,30,0.22)",backdropFilter:"blur(4px)",zIndex:1001,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
      <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,animation:"nx-modal-open 0.3s cubic-bezier(0.16,1,0.3,1) both",width:580,maxHeight:"90vh",display:"flex",flexDirection:"column"}}>
        <div style={{padding:"18px 22px 14px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",flexShrink:0}}>
          <div>
            <div style={{fontSize:17,fontWeight:800,color:T.text}}>⚠️ Réserves & Non-conformités</div>
            <div style={{fontSize:12,color:T.muted,marginTop:3}}>{list.length} déclarée(s) · {intervention.titre}</div>
          </div>
          <div style={{display:"flex",gap:8}}>
            <button onClick={()=>setShowCreate(true)} style={{padding:"7px 14px",borderRadius:9,background:`linear-gradient(135deg,${T.accent},${T.purple})`,border:"none",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer"}}>＋ Déclarer</button>
            <button onClick={onClose} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:22}}>✕</button>
          </div>
        </div>

        <div style={{flex:1,overflowY:"auto",padding:"14px 22px"}}>
          {showCreate&&(
            <div style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:14,padding:16,marginBottom:14}}>
              <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:12}}>Nouvelle déclaration</div>
              <input value={form.titre} onChange={e=>setForm(p=>({...p,titre:e.target.value}))} placeholder="Titre *"
                style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:9,padding:"9px 12px",color:T.text,fontSize:14,outline:"none",width:"100%",marginBottom:8}}/>
              <textarea value={form.description} onChange={e=>setForm(p=>({...p,description:e.target.value}))} placeholder="Description..." rows={3}
                style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:9,padding:"9px 12px",color:T.text,fontSize:13,outline:"none",width:"100%",resize:"vertical",marginBottom:8}}/>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:10}}>
                <div>
                  <div style={{fontSize:11,color:T.muted,marginBottom:5,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.5px"}}>Type</div>
                  <div style={{display:"flex",gap:6}}>
                    {TYPES.map(t=>(
                      <button key={t.id} onClick={()=>setForm(p=>({...p,type:t.id}))}
                        style={{padding:"5px 10px",borderRadius:8,border:`1.5px solid ${form.type===t.id?t.c:T.border}`,background:form.type===t.id?`${t.c}20`:"transparent",color:form.type===t.id?t.c:T.muted,fontSize:11,fontWeight:700,cursor:"pointer"}}>
                        {t.ic} {t.lbl}
                      </button>
                    ))}
                  </div>
                </div>
                <div>
                  <div style={{fontSize:11,color:T.muted,marginBottom:5,fontWeight:700,textTransform:"uppercase",letterSpacing:"0.5px"}}>Criticité</div>
                  <div style={{display:"flex",gap:6}}>
                    {CRITICITES.map(cr=>(
                      <button key={cr.id} onClick={()=>setForm(p=>({...p,criticite:cr.id}))}
                        style={{padding:"5px 10px",borderRadius:8,border:`1.5px solid ${form.criticite===cr.id?cr.c:T.border}`,background:form.criticite===cr.id?`${cr.c}20`:"transparent",color:form.criticite===cr.id?cr.c:T.muted,fontSize:11,fontWeight:700,cursor:"pointer"}}>
                        {cr.lbl}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
              <div style={{display:"flex",gap:8}}>
                <button onClick={()=>setShowCreate(false)} style={{flex:1,padding:"9px",borderRadius:9,border:`1px solid ${T.border}`,background:"transparent",color:T.muted,fontSize:13,cursor:"pointer"}}>Annuler</button>
                <button onClick={create} disabled={!form.titre||saving}
                  style={{flex:2,padding:"9px",borderRadius:9,background:form.titre?T.danger:T.border,border:"none",color:"#fff",fontSize:13,fontWeight:700,cursor:"pointer"}}>
                  ⚠️ Déclarer
                </button>
              </div>
            </div>
          )}

          {list.length===0&&!showCreate&&(
            <div style={{textAlign:"center",padding:40,color:T.muted}}>
              <div style={{fontSize:36,marginBottom:10}}>✅</div>
              <div style={{fontSize:14,fontWeight:700,color:T.text}}>Aucune réserve déclarée</div>
            </div>
          )}

          {list.map(nc=>{
            const type = TYPES.find(t=>t.id===nc.type)||TYPES[0];
            const crit = CRITICITES.find(c=>c.id===nc.criticite)||CRITICITES[0];
            const statut = STATUTS[nc.statut]||STATUTS.ouverte;
            return(
              <div key={nc.id} style={{background:T.bg,border:`1px solid ${T.border}`,borderRadius:12,padding:"12px 14px",marginBottom:8}}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
                  <span style={{fontSize:11,fontFamily:"monospace",color:T.muted,background:T.card,padding:"1px 7px",borderRadius:20,border:`1px solid ${T.border}`}}>{nc.reference}</span>
                  <span style={{fontSize:10,fontWeight:700,color:type.c,background:`${type.c}20`,padding:"2px 8px",borderRadius:20}}>{type.ic} {type.lbl}</span>
                  <span style={{fontSize:10,fontWeight:700,color:crit.c,background:`${crit.c}18`,padding:"2px 8px",borderRadius:20}}>{crit.lbl}</span>
                  <span style={{fontSize:10,fontWeight:700,color:statut.c,background:`${statut.c}18`,padding:"2px 8px",borderRadius:20,marginLeft:"auto"}}>{statut.lbl}</span>
                </div>
                <div style={{fontSize:13,fontWeight:700,color:T.text,marginBottom:4}}>{nc.titre}</div>
                {nc.description&&<div style={{fontSize:12,color:T.muted,marginBottom:6}}>{nc.description}</div>}
                {nc.resolution&&<div style={{fontSize:11,color:T.success,background:`${T.success}10`,borderRadius:8,padding:"6px 10px",marginBottom:6}}>✅ Résolution : {nc.resolution}</div>}
                {nc.statut==="ouverte"&&(
                  <button onClick={()=>resolve(nc.id)}
                    style={{padding:"5px 12px",borderRadius:8,background:`${T.success}20`,border:`1px solid ${T.success}40`,color:T.success,fontSize:11,fontWeight:700,cursor:"pointer"}}>
                    ✅ Résoudre
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
